/* All the global variables, mixins goes here */
@use "sass:math";
@import '../../../static/scss/resources/default.variables.scss';
@import '../../../static/scss/resources/default.style.scss';

.browser-tab-bar {
    padding-left: 5px;
    padding-top: 5px;
    background-color: $color-gray-lighter;
}

code,
kbd,
pre,
samp,
.CodeMirror pre {
  font-family: $font-family-editor !important;
}

.sql-editor-grid-container {
  font-family: $font-family-primary !important;
}

.select2-btn-container {
    padding: 3px 0px;
    background-color: $color-primary;
    margin-bottom: 3px;
}

.pg-sp-container {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  background: $loading-bg;
  z-index: 1056;

  .pg-sp-content {
    position: absolute;
    width: 100%;
    top: 40%;
  }
}
.pg-sp-icon {
  background: $loader-icon center center no-repeat;
  height: 75px;
  width: 100%;
  text-align: center;
}
.pg-sp-text {
  font-size: 20px;
  text-align: center;
  color: $loading-fg;
}

.pg-toolbar-btn {
  margin-left: 0.25rem;
  border-style: solid;
  border-width: 1px;
  font-size: 1.15em;
}

.pg-toolbar-psql {
  padding-top: 0em;
  font-size: inherit;
  align-items: center;
}
